import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CommonFunctions from "../Utils/CommonFunctions";
class FooterMobile extends Component {
  constructor(props) {
    super(props);
    let urlParams = new URLSearchParams(window.location.search);
    let myParam = urlParams.get('mobile');
    this.state = {
      language: CommonFunctions.getSelectedLanguage(), // get the selected language
      activeclass:this.props.activeclass,
      Footer:myParam=='yes'?false:true,
    };
  }

  //goto scrolltop
  Scrolltopfun(e) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search);
    let myParam = urlParams.get('mobile');
    if(myParam=='yes'){
      this.setState({ Footer: false });
    }
  }
  render() {
    return (
       <div>
         {this.state.Footer && (
        <div className="appBottomMenu"> 
        <Link className={this.state.activeclass=="home"?"item active":"item"} to="/Index">
          <div className="col">
             <img width="20" src={process.env.REACT_APP_BASE_URL + "/images/homepage-icon.svg"} alt="" className="imaged" />
          </div>
          </Link> 
          <Link className={this.state.activeclass=="theme"?"item active":"item"} to="/Themes">
            <div className="col">
            <img width="20" src={process.env.REACT_APP_BASE_URL + "/images/four-squares-icon.svg"} alt="" className="imaged" />
            </div>
          </Link> 
          <Link to="/ContactUs" className={this.state.activeclass=="contact"?"item active":"item"}>
             <div className="col"> 
             <img width="20" src={process.env.REACT_APP_BASE_URL + "/images/mail-icon.svg"} alt="" className="imaged" /> 
             </div>
          </Link> 
          <Link className={this.state.activeclass=="info"?"item active":"item"} to="/InfoPage">
             <div className="col">
                 <img width="20" src={process.env.REACT_APP_BASE_URL + "/images/info-circle-icon.svg"} alt="" className="imaged" />
             </div>
          </Link> 
        </div>
         )}
        </div>
      
    );
  }
}

export default withTranslation()(FooterMobile);
